import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { FieldListComponent } from '@mode/switch-views/feature-fieldlist';

export const DowngradedSwitchViewsFeatureFieldlistModule = angular
  .module('downgraded-switch-views-feature-fieldlist', [])
  .directive('modeFieldList', downgradeComponent({ component: FieldListComponent })).name;
